import { Article } from "@/lib/types";
import { SectionHead } from "../shared";
import { MoreStoriesLiveFeed } from "./LiveFeed";
import { TrendingPanel } from "./TrendingPanel";
import { PremiumInsightCard } from "./PremiumInsightCard";

/* More Stories — locked FRESH COVERAGE / LIVE NEWSSTREAM architecture:
   dominant live feed left · Trending Now + Premium Insight right rail. */
export const MoreStoriesSection = ({ articles, excludeSlugs }: {
  articles: Article[]; excludeSlugs: string[];
}) => {
  if (!articles.length) return null;
  return (
    <section data-testid="more-stories" className="mt-10 sm:mt-14" aria-labelledby="more-stories-title">
      <span id="more-stories-title" className="sr-only">More Stories — live newsstream</span>
      <SectionHead label="Fresh coverage" title="More Stories"
        cta="All latest news" to="/latest" testid="more-stories-cta" module="more_stories" />
      <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,68fr)_minmax(0,32fr)] gap-4 items-stretch">
        <MoreStoriesLiveFeed initial={articles} excludeSlugs={excludeSlugs} />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:flex lg:flex-col gap-4 min-w-0">
          <TrendingPanel />
          <PremiumInsightCard />
        </div>
      </div>
    </section>
  );
};
